import Vue from 'vue';
import router from '../common/router';
import http from '../common/http';
import common from '../common/common';
import config from '../common/config';
import util from '../common/util';
import App from './App.vue';
import RouterTab from 'vue-router-tab';
import ViewUI from 'view-design';
import message from '../common/message.js';
import store from '../common/store.js';
import 'vue-router-tab/dist/lib/vue-router-tab.css';
import 'view-design/dist/styles/iview.css';
import './assets/bootstrap.min.css';
import './assets/main.css';
import dataV from '@jiaminghi/data-view';
//import * as echarts from "../node_modules/echarts/echarts.all";
import echarts from 'echarts'

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';


// 引入高德地图
// import VueAMap from 'vue-amap';
 
// Vue.use(VueAMap);
 
 
// 初始化vue-amap
// VueAMap.initAMapApiLoader({
//   // 高德的key
//   key: 'eb73ef55539d3a9f9555ceef97a088dc',
//   // 插件集合
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 高德 sdk 版本，默认为 1.4.4
//   v: '1.4.4'
// });




Vue.use(VueQuillEditor);

Vue.use(dataV)
Vue.use(RouterTab);
Vue.use(ViewUI);
Vue.use(echarts);

Vue.prototype.http = http;
Vue.prototype.store = store;
Vue.prototype.common = common;
Vue.prototype.message = message;
Vue.prototype.util = util;
Vue.prototype.config = config;
Vue.prototype.echarts = echarts;

if (process.env.NODE_ENV === "local") {
	require('../common/mock.js');
}
new Vue({
  render: h => h(App),
  router
}).$mount('#app');